import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RatingsList = ({ ratings, onClick, selectedRatings, loading }) => {
  if (loading) {
    return [1, 2, 3, 4, 5].map(() => (
      <div className="tvt-reactions__ratings-loading" />
    ));
  }

  if (!ratings) {
    return null;
  }

  const formatStars = rating => {
    const stars = [];

    for (let index = 1; index <= 5; index++) {
      stars.push(
        <FontAwesomeIcon
          className={`tvt-reactions__comment-rating-star ${
            index <= rating || 0 ? 'active' : 'inactive'
          }`}
          icon="star"
          size="1x"
        />
      );
    }

    return stars;
  };

  const starsToText = ['', 'BAD', 'OK', 'GOOD', 'GREAT', 'WOW'];
  const totalVotes = ratings.reduce((total, c) => total + c.votes, 0);

  const onClickRating = r => () => onClick(r);

  return (
    <div className="tvt-reactions__ratings-list-wrapper">
      {ratings.map(rating => (
        <button
          alt="rating"
          onClick={onClickRating(rating.stars)}
          className={`tvt-reactions__ratings-wrapper ${
            selectedRatings.includes(rating.stars) ? 'selected' : ''
          }`}
        >
          <div className="tvt-reactions__ratings-stars-wrapper">
            <div>{formatStars(rating.stars)}</div>
            <div className="tvt-reactions__ratings-stars-text">
              {starsToText[rating.stars]}
            </div>
          </div>
          <div className="tvt-reactions__character-bar-wrapper">
            <div
              className="tvt-reactions__character-votes-bar"
              style={{
                width: `${Math.floor((rating.votes / totalVotes) * 100)}%`
              }}
            />
          </div>
          <div className="tvt-reactions__character-votes-wrapper">
            <div>{numeral(rating.votes).format(',')}</div>
            <div>reactions</div>
          </div>
        </button>
      ))}
    </div>
  );
};

RatingsList.propTypes = {
  ratings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired
};

RatingsList.defaultProps = {};

export default RatingsList;
